/**
 * 将某个组件对象暴露给他的所有子组件(要暴露的组件作为一个数据中心而存在)
 * 使用方法
 * Vue.use(datacenter);
 * 要暴露的对象的data上需要定义 isDataCenter: true
 * 示例：
 * import datacenter from 'datacenter'
 * Vue.use(datacenter);
 *
 * App.vue要将自己暴露给所有子组件
 * export default {
 *   data() {
 *     return {
 *       isDataCenter: true
 *     }
 *   }
 * }
 * 在子组件中引被暴露的对象的方式为
 * this.$dc
 * 如果没有组件定义了isDataCenter字段、或者引用了数据中心组件上未定义的字段，则会在控制台上提示错误
 * Created by tsxuehu on 17/3/19.
 */
var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/)

var dataContainer = null
var proxy = null
var returnNoopFunFlag = false;
function noop() {
}
if (hasProxy) {
    proxy = new Proxy({}, {
        get: function (target, key) {
            if (!dataContainer) {
                console.error('[datacenter error]没有定义datacenter，请在作为数据中心的组件上增加isDataCenter字段，值为true')
                return
            }
            if (typeof key === 'string' && !(key in dataContainer)) {
                console.error('[datacenter error]datacenter组件上不存在字段: ' + key)
                return
            }
            if (returnNoopFunFlag) {
                if (typeof dataContainer[key] == 'function') {
                    console.warn('[datacenter error]datacenter returnNoopFunFlag为true，返回空函数: ' + key)
                    return noop
                }
            }
            return dataContainer[key]
        },
        set: function (target, key, value, receiver) {
            console.warn('[datacenter error]不建议对数据组件直接赋值，请通过数据组件里的method修改数据', key, value)
            dataContainer[key] = value
            return true
        }
    })
}

var installed;
function datacenterInit() {
    // 设置dataContainer
    if (!dataContainer && this.$data && this.$data.isDataCenter) {
        dataContainer = this
    }
    // 给实例上添加字段
    if (proxy) {
        this.$dc = proxy
    } else {
        this.$dc = dataContainer
    }
}
module.exports = {
    install: function (Vue) {
        if (installed) return
        installed = true
        Vue.mixin({created: datacenterInit})
    },
    returnNoopFun: function (flag) {
        returnNoopFunFlag = flag
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-data-center/lib/data-center.js
// module id = 28
// module chunks = 3